export default __webpack_public_path__ + "static/loja-6-fa78c99cf4f5c20c22e5443af59b3736.png";